import styled from 'styled-components';
import { FONTS, COLORS, SIZE, FONT_SIZE } from '@app/src/ui';

export const Wrapper = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: ${FONT_SIZE.SHORT};
  color: ${COLORS.GRAY_PLACEHOLDER};

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }

  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    margin-right: 108px;
  }
`;

export const Active = styled.span`
  color: ${COLORS.GRAY_DARK};
  font-weight: 600;
`;
